export default "__VITE_PUBLIC_ASSET__9f12356a__"